import React, { useState, useRef, useEffect } from 'react';
import "./index.less"
import { ReactComponent as SoundSvg } from "./icons/sound.svg"
import { ReactComponent as Go15Svg } from "./icons/go-15.svg"
import { ReactComponent as UnGo15Svg } from "./icons/ungo-15.svg"
import { ReactComponent as WhitePlaySvg } from "./icons/white-play.svg"
import { ReactComponent as WhiteStopSvg } from "./icons/white-stop.svg"

import ContextMenu from '@/baseui/right-menu/context-menu';
import classNames from 'classnames';

const speedList = [
    { value: 3, label: "3X" },
    { value: 2, label: "2X" },
    { value: 1.5, label: "1.5X" },
    { value: 1, label: "1X" },
    { value: 0.5, label: "0.5X" }
]

interface IProps {
    audioUrl: string
    duration: number
}

const MyAudioPlayer = (props: IProps) => {

    const { audioUrl, duration } = props

    const audioRef = useRef(null);
    const progressRef = useRef(null);
    const circleRef = useRef(null);

    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    // const [duration, setDuration] = useState(0);
    const [volume, setVolume] = useState(1); // 音量默认值为 1（最大）
    const [playbackRate, setPlaybackRate] = useState(1); // 倍速默认值为 1（正常）
    const [isSeeking, setIsSeeking] = useState(false); // 是否正在拖动进度条
    const [cmTop, setCmTop] = useState<number>(); // 右键菜单的定位
    const [cmLeft, setCmLeft] = useState<number>(); // 右键菜单的定位
    const [soundMenuVisiable, setSoundMenuVisiable] = useState<boolean>(false)
    const [speedMenuVisiable, setSpeedMenuVisiable] = useState<boolean>(false)

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.addEventListener('timeupdate', () => {
                if (!isSeeking) {
                    setCurrentTime(audioRef.current?.currentTime);
                }
            });

            return () => {
                if (audioRef.current) {
                    audioRef.current.removeEventListener('timeupdate', () => { });
                }
            };
        }
    }, [isSeeking]);

    useEffect(() => {
        if (audioUrl && audioUrl?.length > 0) {
            if (audioRef.current) {
                setIsPlaying(true)
                audioRef.current.play();
            }
        }
    }, [audioUrl])

    // 播放/暂停切换
    const togglePlay = () => {
        if (!!!audioUrl || audioUrl?.length <= 0) return
        if (isPlaying) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    // 处理进度条点击
    const handleProgressChange = (e) => {
        if (progressRef.current && circleRef.current) {
            const newTime = (e.nativeEvent.offsetX / progressRef.current.offsetWidth) * duration;
            audioRef.current.currentTime = newTime;
            setCurrentTime(newTime);
        }
    };

    // 开始拖动进度条
    const handleProgressMouseDown = () => {
        setIsSeeking(true);
    };

    // 拖动中
    const handleProgressMouseMove = (e) => {
        if (isSeeking && progressRef.current && circleRef.current) {
            const newTime = (e.nativeEvent.offsetX / progressRef.current.offsetWidth) * duration;
            audioRef.current.currentTime = newTime;
            setCurrentTime(newTime);
        }
    };

    // 停止拖动进度条
    const handleProgressMouseUp = () => {
        setIsSeeking(false);
    };

    // 跳转到加减的时间
    const handleSeek = (time) => {

        const newTime = Math.max(0, Math.min(duration, currentTime + time));
        audioRef.current.currentTime = newTime;
        setCurrentTime(newTime);
    };

    // 处理音量改变
    const handleVolumeChange = (e) => {
        const newVolume = e.target.value;
        setVolume(newVolume);
        audioRef.current.volume = newVolume;
    };

    // 处理倍速改变
    const handlePlaybackRateChange = (e: number) => {
        const newRate = e;
        setPlaybackRate(newRate);
        audioRef.current.playbackRate = newRate;
    };

    const onClickSoundIcon = () => {
        let doc = document.getElementById("sound-icon")
        if (!doc) return
        const left = doc.getBoundingClientRect().left - 15;
        const top = doc.getBoundingClientRect().top;
        setSoundMenuVisiable(true)
        setCmLeft(left)
        setCmTop(top)
    }

    const onClickSpeedIcon = () => {
        let doc = document.getElementById("speed-icon")
        if (!doc) return
        const left = doc.getBoundingClientRect().right;
        const top = doc.getBoundingClientRect().top;
        setSpeedMenuVisiable(true)
        setCmLeft(left)
        setCmTop(top)
    }

    return (
        <div className="my-audio-player">
            <audio ref={audioRef} src={audioUrl} />

            <div className="controls">
                <SoundSvg id='sound-icon' className='icon-small' onClick={() => { onClickSoundIcon() }} />

                <UnGo15Svg className='icon-small' onClick={() => handleSeek(-15)} />
                <div className="play" onClick={togglePlay} >
                    {!isPlaying && <WhitePlaySvg className="play-icon" />}
                    {isPlaying && <WhiteStopSvg className="play-icon" />}
                </div>
                <Go15Svg className='icon-small' onClick={() => handleSeek(15)} />
                <div className='speed' id='speed-icon' onClick={() => { onClickSpeedIcon() }}>{playbackRate + "X"}</div>
            </div>
            <div className='detail'>
                <span style={{ userSelect: "none" }}>{formatTime(currentTime)}</span>
                {/* 进度条部分 */}
                <div
                    className="progress-container"
                    ref={progressRef}
                    onClick={handleProgressChange}
                    onMouseDown={handleProgressMouseDown}
                    onMouseMove={handleProgressMouseMove}
                    onMouseUp={handleProgressMouseUp}
                    onMouseLeave={handleProgressMouseUp}
                >
                    <div
                        className="progress-bar"
                        style={{ width: `${(currentTime / duration) * 100}%` }}
                    ></div>
                    {/* <div
                        ref={circleRef}
                        className="progress-circle"
                        style={{ background: "red", left: `${(currentTime / duration) * 100}%` }}
                    ></div> */}
                </div>
                <span style={{ userSelect: "none" }}>{formatTime(duration)}</span>
            </div>

            <ContextMenu
                wrapperClassname='sound-menu'
                visible={soundMenuVisiable}
                left={cmLeft}
                top={cmTop}
                width={50}
                onCancel={() => { setSoundMenuVisiable(false) }}
            >
                <div className='sound-num'>{(volume * 100).toFixed(0) + "%"}</div>
                <input
                    className='sound-line'
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    value={volume}
                    onChange={handleVolumeChange}
                />
            </ContextMenu>

            <ContextMenu
                wrapperClassname='speed-menu'
                visible={speedMenuVisiable}
                left={cmLeft}
                top={cmTop}
                width={60}
                onCancel={() => { setSpeedMenuVisiable(false) }}
            >

                {speedList.map(speedItem => (
                    <div
                        className={classNames({
                            'speed-item': true,
                            'speed-item-active': speedItem.value == playbackRate
                        })}
                        key={speedItem.value}
                        onClick={() => {
                            handlePlaybackRateChange(speedItem.value)
                            setSpeedMenuVisiable(false)
                        }}
                    >
                        {speedItem.label}
                    </div>
                ))}
            </ContextMenu>
        </div>
    );
};

// 格式化时间
const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};

export default MyAudioPlayer;
